/* eslint-disable max-len */
import React from 'react';

 const SVGIconEdit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        id="Group_6455"
        data-name="Group 6455"
        transform="translate(-1537 519)"
      >
        <rect
          id="BG"
          width="20"
          height="20"
          rx="4"
          transform="translate(1537 -519)"
          fill="rgba(255,255,255,0)"
        />
        <path
          id="pen-solid"
          className="SVGIcon_colorFill"
          d="M8.511,1.011a1.5,1.5,0,0,1,2.126,0l.925.925a1.5,1.5,0,0,1,0,2.125L10.426,5.2l-3.05-3.05ZM9.9,5.727,4.423,11.2a2.057,2.057,0,0,1-.878.521l-2.824.831a.529.529,0,0,1-.557-.162.516.516,0,0,1-.142-.537L.854,9.027a2.069,2.069,0,0,1,.521-.878l5.47-5.471Z"
          transform="translate(1541 -515.571)"
          fill="#409573"
        />
      </g>
    </svg>
  );
};

export default SVGIconEdit